import { render } from "./UpdatePasswordView.vue?vue&type=template&id=84bafe5a"
import script from "./UpdatePasswordView.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__